/**
 * Small helpers reused across the Revenue admin screens.
 */
import { api } from "@/lib/api";

export const TX_TYPES = [
    { value: "SUBSCRIPTION", label: "Subscription", tone: "orange" },
    { value: "COUPON_TOPUP", label: "Coupon Top-up", tone: "amber" },
    { value: "MOVIE_COMMISSION", label: "Movie commission", tone: "rose" },
    { value: "EVENT_PROMOTION_FEE", label: "Event promo fee", tone: "violet" },
    { value: "MALL_AD_CONTRACT", label: "Mall ad contract", tone: "sky" },
    { value: "AFFILIATE_CLICK_PAYOUT", label: "Affiliate payout", tone: "emerald" },
    { value: "OTHER", label: "Other", tone: "slate" },
];

export const TX_STATUSES = ["COMPLETED", "PENDING", "REFUNDED", "VOID"];

export const PAYMENT_METHODS = ["CASH", "UPI", "BANK_TRANSFER", "CARD", "OTHER"];

export const BILLING_CYCLES = [
    { value: "MONTHLY", label: "Monthly", months: 1 },
    { value: "QUARTERLY", label: "Quarterly", months: 3 },
    { value: "ANNUAL", label: "Annual", months: 12 },
];

export const SUBSCRIPTION_STATUSES = ["ACTIVE", "EXPIRED", "CANCELLED"];
export const PAYMENT_STATUSES = ["PAID", "PENDING", "REFUNDED"];

export const TX_TONE_CLASSES = {
    orange: "bg-orange-100 text-orange-700 border-orange-200",
    amber: "bg-amber-100 text-amber-700 border-amber-200",
    rose: "bg-rose-100 text-rose-700 border-rose-200",
    violet: "bg-violet-100 text-violet-700 border-violet-200",
    sky: "bg-sky-100 text-sky-700 border-sky-200",
    emerald: "bg-emerald-100 text-emerald-700 border-emerald-200",
    slate: "bg-slate-100 text-slate-700 border-slate-200",
};

export const STATUS_TONE = {
    ACTIVE: "bg-emerald-100 text-emerald-700 border-emerald-200",
    EXPIRED: "bg-neutral-200 text-neutral-600 border-neutral-300",
    CANCELLED: "bg-rose-100 text-rose-700 border-rose-200",
    PAID: "bg-emerald-100 text-emerald-700 border-emerald-200",
    PENDING: "bg-amber-100 text-amber-800 border-amber-200",
    REFUNDED: "bg-rose-100 text-rose-700 border-rose-200",
    COMPLETED: "bg-emerald-100 text-emerald-700 border-emerald-200",
    VOID: "bg-neutral-200 text-neutral-500 border-neutral-300",
    EXHAUSTED: "bg-neutral-200 text-neutral-600 border-neutral-300",
};

export const CHART_COLORS = [
    "#FF7A1A", // brand orange
    "#FFC300", // brand yellow
    "#38bdf8", // sky
    "#a78bfa", // violet
    "#34d399", // emerald
    "#f472b6", // pink
    "#94a3b8", // slate
];

let _shopOwnersCache = null;
export async function fetchShopOwners(force = false) {
    if (_shopOwnersCache && !force) return _shopOwnersCache;
    const res = await api.get("/admin/users?role=SHOP_OWNER");
    // Only cache on success; do not cache empty/undefined
    if (Array.isArray(res.data)) {
        _shopOwnersCache = res.data;
    }
    return res.data;
}

export function todayIso() {
    return new Date().toISOString().slice(0, 10);
}

export function monthNameOf(y, m) {
    return new Date(y, m - 1, 1).toLocaleString("en-IN", { month: "short", year: "numeric" });
}
